/**
 * Karadayı — Slider sayaçlarını nokta (dots) göstergesine çevirir.
 *
 * Dawn'da noktalar yalnızca <slideshow-component> için bağlanmış durumda.
 * Diğer tüm slider'lar (öne çıkan koleksiyon, koleksiyon listesi, multicolumn,
 * blog, yorumlar, ürün galerisi) "1 / 5" biçiminde metin sayaç gösteriyor.
 *
 * Bu dosya o metin sayacı gizleyip yerine tıklanabilir noktalar koyar.
 * Dawn'ın kendi dosyalarına dokunmaz; SliderComponent'in zaten yaydığı
 * 'slideChanged' olayını dinler. JS çalışmazsa metin sayaç olduğu gibi kalır.
 */
(function () {
  'use strict';

  var MAX_DOTS = 12; // bundan fazlaysa nokta yerine metin sayaç kalsın

  function pageCount(sliderEl) {
    var total = sliderEl.querySelector('.slider-counter--total');
    var n = total ? parseInt(total.textContent, 10) : 0;
    return isNaN(n) ? 0 : n;
  }

  function currentPage(sliderEl) {
    var cur = sliderEl.querySelector('.slider-counter--current');
    var n = cur ? parseInt(cur.textContent, 10) : 1;
    return isNaN(n) ? 1 : n;
  }

  function setActive(dotsEl, page) {
    var dots = dotsEl.querySelectorAll('.kdd__dot');
    for (var i = 0; i < dots.length; i++) {
      var on = i === page - 1;
      dots[i].classList.toggle('kdd__dot--on', on);
      if (on) dots[i].setAttribute('aria-current', 'true');
      else dots[i].removeAttribute('aria-current');
    }
  }

  function goTo(sliderEl, index) {
    var track = sliderEl.slider || sliderEl.querySelector('.slider');
    if (!track) return;
    var offset = sliderEl.sliderItemOffset;
    if (!offset) {
      var items = track.querySelectorAll('[id^="Slide-"]');
      if (items.length > 1) offset = items[1].offsetLeft - items[0].offsetLeft;
    }
    if (!offset) return;
    track.scrollTo({ left: offset * index, behavior: 'smooth' });
  }

  function build(sliderEl, counterEl) {
    var total = pageCount(sliderEl);

    var existing = sliderEl.querySelector('.kdd');
    if (total < 2 || total > MAX_DOTS) {
      if (existing) existing.remove();
      counterEl.classList.remove('kdd-hidden');
      return;
    }

    // Aynı sayıda nokta zaten varsa yeniden kurma
    if (existing && existing.children.length === total) {
      setActive(existing, currentPage(sliderEl));
      return;
    }
    if (existing) existing.remove();

    var wrap = document.createElement('div');
    wrap.className = 'kdd';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Slayt göstergesi');

    for (var i = 0; i < total; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'kdd__dot';
      b.setAttribute('aria-label', (i + 1) + '. slayta git');
      b.dataset.index = String(i);
      b.addEventListener('click', function (e) {
        goTo(sliderEl, parseInt(e.currentTarget.dataset.index, 10));
      });
      wrap.appendChild(b);
    }

    counterEl.classList.add('kdd-hidden');
    counterEl.parentNode.insertBefore(wrap, counterEl.nextSibling);
    setActive(wrap, currentPage(sliderEl));
  }

  function attach(sliderEl) {
    if (sliderEl.dataset.kddReady === '1') return;

    // slideshow-component'in kendi noktaları var, dokunma
    if (sliderEl.tagName.toLowerCase() === 'slideshow-component') return;

    var counterEl = sliderEl.querySelector('.slider-counter');
    if (!counterEl || !sliderEl.querySelector('.slider-counter--total')) return;
    // Dawn'ın hazır nokta/numara bağlantıları varsa karışma
    if (counterEl.querySelector('.slider-counter__link')) return;

    sliderEl.dataset.kddReady = '1';

    build(sliderEl, counterEl);

    sliderEl.addEventListener('slideChanged', function (e) {
      var dots = sliderEl.querySelector('.kdd');
      if (dots) setActive(dots, e.detail.currentPage);
    });

    // Toplam sayfa sayısı ekran boyutuyla değişebiliyor
    var totalEl = sliderEl.querySelector('.slider-counter--total');
    new MutationObserver(function () {
      build(sliderEl, counterEl);
    }).observe(totalEl, { childList: true, characterData: true, subtree: true });
  }

  function scan(root) {
    (root || document).querySelectorAll('slider-component').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // Tema düzenleyicide bölüm yeniden çizildiğinde
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
